import {defineStore} from 'pinia';
import {ref} from 'vue';
import {getSaasConfig} from "@/api/system";

export const saasStore = defineStore('saas', () => {
    const saasObj = ref({});

    function getSaasObj() {
        return new Promise((resolve, reject) => {
            getSaasConfig().then((res) => {
                saasObj.value = res
                resolve(res);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    return {
        saasObj,
        getSaasObj,
    };
}, {
    persist: true // 头部余额不更新不及时，因此关闭了存储持久化
});
